<script setup>
import InputCheckbox    from "@/components/form/InputCheckbox.vue";

const props = defineProps({
  errors: Object,
  inputs: Object,
  eIds: Object,
  validators: Object,
});
</script>
<template>
  <div>
    <div v-show="eIds.personalForms.length + eIds.mpaForms.length + eIds.teamForms.length <= 1">
      <InputCheckbox
        v-model="inputs.cbAckLegalOrgSingleMembership"
        name="cbAckLegalOrgSingleMembership"
        :error="errors.cbAckLegalOrgSingleMembership"
        @validate="(event) => validators.checked(event)"
        >
          <template v-slot:label>
            <i18n-t keypath="contractDetail.forOrganization.cbAckLegalOrgSingleMembership" tag="p" scope="global">
              <template v-slot:cbAckLegalOrgSingleMembershipContract>
                <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('contractDetail.forOrganization.cbAckLegalOrgSingleMembershipContractLink')">
                  {{ $t("contractDetail.forOrganization.cbAckLegalOrgSingleMembershipContract") }}
                </a>
              </template>
            </i18n-t>
          </template>
        </InputCheckbox>
      <InputCheckbox
        v-model="inputs.cbAckLegalOrgSinglePersonallyResponsible"
        name="cbAckLegalOrgSinglePersonallyResponsible"
        :label="$t('contractDetail.forOrganization.cbAckLegalOrgSinglePersonallyResponsible')"
        :error="errors.cbAckLegalOrgSinglePersonallyResponsible"
        @validate="(event) => validators.checked(event)"
      />
    </div>
    <div v-show="eIds.personalForms.length + eIds.mpaForms.length + eIds.teamForms.length > 1">
      <InputCheckbox
        v-model="inputs.cbAckLegalOrgCollectiveMembership"
        name="cbAckLegalOrgCollectiveMembership"
        :error="errors.cbAckLegalOrgCollectiveMembership"
        @validate="(event) => validators.checked(event)"
        >
          <template v-slot:label>
            <i18n-t keypath="contractDetail.forOrganization.cbAckLegalOrgCollectiveMembership" tag="p" scope="global">
              <template v-slot:cbAckLegalOrgCollectiveMembershipContract>
                <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('contractDetail.forOrganization.cbAckLegalOrgCollectiveMembershipContractLink')">
                  {{ $t("contractDetail.forOrganization.cbAckLegalOrgCollectiveMembershipContract") }}
                </a>
              </template>
            </i18n-t>
          </template>
        </InputCheckbox>
    </div>
  </div>
</template>

